<script>
  export let eyebrow = '';
  export let title = '';
  export let desc = '';
  export let big = false; // larger headline size
  export let glow = false; // apply glow text-shadow
</script>

<div>
  {#if eyebrow}
    <div class="eyebrow">{eyebrow}</div>
  {/if}
  <h2 class="section-header" class:big-head={big} class:glow={glow}>
    <slot name="title">{title}</slot>
  </h2>
  <p class="desc" style="color: var(--muted); font-size: 18px; line-height:1.7; max-width: 72ch; margin: 8px 0 0;">
    <slot name="desc">{desc}</slot>
  </p>
</div>

<style>
  .section-header { font-size: clamp(28px, 4.5vw, 44px); margin: 10px 0 12px; }
  .section-header.big-head { font-size: clamp(36px, 6vw, 64px); }
  .section-header:empty { display: none; }
  .desc:empty { display: none; }
</style>
